import { useCallback, useState } from 'react';

import { ICursor } from '@/store/types/search.types';

export function useCursor(
  cursor: ICursor | undefined = undefined,
  itemPerPage: number,
  handleNavigation: (cursorId: string) => void | undefined = undefined,
): {
  itemCount: number;
  activePage: number;
  itemPerPage: number;
  onPageChange: (selectedItem: { selected: number }) => void;
} {
  const [activePage, setActivePage] = useState(0);
  const next = cursor?.next;
  const prev = cursor?.prev;

  const onPageChange = useCallback(
    (item) => {
      const direction = item.selected - activePage;
      if (handleNavigation) {
        if (direction === 1 && next) {
          handleNavigation(next);
        } else if (direction === -1 && prev) {
          handleNavigation(prev);
        }
      }

      setActivePage(activePage + direction);
    },
    [activePage, handleNavigation, next, prev],
  );

  const itemCount = !cursor ? itemPerPage : !!next ? (activePage + 2) * itemPerPage : (activePage + 1) * itemPerPage;

  return {
    itemCount,
    activePage,
    itemPerPage,
    onPageChange,
  };
}
